import React from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";

/**
 * Created by dannyr on 30/11/2016.
 */

interface PlainTooltipContentProps {
    text: React.ReactNode;
    dangerouslySetInnerHTML?: boolean;
}

export class PlainTooltipContent extends React.Component<PlainTooltipContentProps> {
    public static defaultProps = {
        text: "MISSING_TEXT",
        dangerouslySetInnerHTML: false,
    };

    public render() {
        const { text } = this.props;
        if (typeof text === "string") {
            return (
                <div>
                    <I18n dangerouslySetInnerHTML={this.props.dangerouslySetInnerHTML}>{this.props.text}</I18n>
                </div>
            );
        }
        return <div>{this.props.text}</div>;
    }
}
